import { ProductInventoryRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class ProductInventoryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ProductInventoryRouteService());
	}

	createBatch(productInventoryBatch, sourceOfChange) {
		var url = this.routeService.createBatch(sourceOfChange);
		return this.apiClient.post(url, productInventoryBatch);
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	sync(filter) {
		var url = this.routeService.sync(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default ProductInventoryService;



// WEBPACK FOOTER //
// ./src/common/data/services/ProductInventoryService.js